(function () {
  class Lucrative_DataLayer {
    constructor() {
      window.dataLayer = window.dataLayer || [];

      this.eventPrefix = 'LD';
      this.formattedItemId = true;

      this.dataSchema = {
        ecommerce: { show: true },
        dynamicRemarketing: { show: false, business_vertical: 'retail' }
      };

      this.addToWishListSelectors = {
        addWishListIcon: '',
        gridItemSelector: '',
        productLinkSelector: 'a[href*="/products/"]'
      };

      this.quickViewSelector = {
        quickViewElement: '',
        gridItemSelector: '',
        productLinkSelector: 'a[href*="/products/"]'
      };

      this.miniCartButton = ['a[href="/cart"]'];
      this.miniCartAppersOn = 'click';

      this.beginCheckoutButtons = [
        'input[name="checkout"]',
        'button[name="checkout"]',
        'a[href="/checkout"]',
        '.additional-checkout-buttons',
      ];

      this.shopifyDirectCheckoutButton = ['.shopify-payment-button'];

      this.isAddToCartRedirect = true;
      this.isAjaxCartIncrementDecrement = true;

      // Legge i dati Liquid dal config object iniettato inline
      var cfg = window.LucrativeConfig || {};
      this.cart = cfg.cart || { items: [], currency: 'EUR', total_price: 0 };
      this.countryCode = cfg.countryCode || '';
      this.storeURL = cfg.storeURL || '';

      this.collectData();
      localStorage.setItem('shopCountryCode', this.countryCode);
    }

    updateCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (data) { this.cart = data; }.bind(this));
    }

    debounce(delay) {
      var timeoutId;
      return function (func) {
        var context = this;
        var args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () { func.apply(context, args); }, delay);
      };
    }

    collectData() {
      var cfg = window.LucrativeConfig || {};
      var page = cfg.page || {};

      this.customerData();
      this.ajaxRequestData();
      this.searchPageData();
      this.miniCartData();
      this.beginCheckoutData();

      if (page.isCart)       this.viewCartPageData();
      if (page.isProduct)    this.productSinglePage();
      if (page.isCollection) this.collectionsPageData();

      this.addToWishListData();
      this.quickViewData();
      this.formData();
      this.phoneClickData();
      this.emailClickData();
    }

    customerData() {
      var cfg = window.LucrativeConfig || {};
      var currentUser = {};

      if (cfg.customer && cfg.customer.email) {
        currentUser = cfg.customer;
      }

      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ customer: currentUser });
    }

    ajaxRequestData() {
      var self = this;
      var cartURL = '/cart';

      if (this.isAddToCartRedirect) {
        document.addEventListener('submit', function (event) {
          var addToCartForm = event.target.closest('form[action="/cart/add"]');
          if (addToCartForm) {
            event.preventDefault();
            var formData = new FormData(addToCartForm);
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              body: formData
            }).then(function () {
              window.location.href = cartURL;
            }).catch(function (error) {
              console.error('Error:', error);
            });
          }
        });
      }

      var originalFetch = window.fetch;
      var debounce = this.debounce(800);

      window.fetch = function () {
        var _arg0 = arguments[0];
        var requestURL = typeof _arg0 === 'string' ? _arg0
          : (_arg0 instanceof Request ? _arg0.url
          : (_arg0 instanceof URL ? _arg0.href : String(_arg0)));
        return originalFetch.apply(this, arguments).then(function (response) {
          if (response.ok) {
            var cloneResponse = response.clone();

            if (/.*\/search\/?.*\?.*q=.+/.test(requestURL) && !requestURL.includes('&requestFrom=uldt')) {
              var queryString = requestURL.split('?')[1];
              var urlParams = new URLSearchParams(queryString);
              var search_term = urlParams.get('q');

              debounce(function () {
                fetch(self.storeURL + '/search/suggest.json?q=' + search_term + '&resources[type]=product&requestFrom=uldt')
                  .then(function (r) { return r.json(); })
                  .then(function (data) {
                    var products = data.resources.results.products;
                    if (products.length) {
                      var fetchRequests = products.map(function (product) {
                        return fetch(self.storeURL + '/' + product.url.split('?')[0] + '.js')
                          .then(function (r) { return r.json(); })
                          .catch(function (e) { console.error('Error fetching:', e); });
                      });
                      Promise.all(fetchRequests).then(function (products) {
                        var items = products.map(function (product) {
                          return {
                            product_id: product.id,
                            product_title: product.title,
                            variant_id: product.variants[0].id,
                            variant_title: product.variants[0].title,
                            vendor: product.vendor,
                            total_discount: 0,
                            final_price: product.price_min,
                            product_type: product.type,
                            quantity: 1
                          };
                        });
                        self.ecommerceDataLayer('search', { search_term: search_term, items: items });
                      });
                    } else {
                      self.ecommerceDataLayer('search', { search_term: search_term, items: [] });
                    }
                  });
              });
            } else if (requestURL.includes('/cart/add')) {
              cloneResponse.text().then(function (text) {
                var data = JSON.parse(text);
                if (data.items && Array.isArray(data.items)) {
                  data.items.forEach(function (item) {
                    self.ecommerceDataLayer('add_to_cart', { items: [item] });
                  });
                } else {
                  self.ecommerceDataLayer('add_to_cart', { items: [data] });
                }
                self.updateCart();
              });
            } else if (requestURL.includes('/cart/change') || requestURL.includes('/cart/update')) {
              cloneResponse.text().then(function (text) {
                var newCart = JSON.parse(text);
                var newCartItems = newCart.items;
                var oldCartItems = self.cart.items;
                for (var i = 0; i < oldCartItems.length; i++) {
                  var item = oldCartItems[i];
                  var newItem = newCartItems.find(function (n) { return n.id === item.id; });
                  if (newItem) {
                    if (newItem.quantity > item.quantity) {
                      self.ecommerceDataLayer('add_to_cart', { items: [Object.assign({}, item, { quantity: newItem.quantity - item.quantity })] });
                      self.updateCart();
                    } else if (newItem.quantity < item.quantity) {
                      self.ecommerceDataLayer('remove_from_cart', { items: [Object.assign({}, item, { quantity: item.quantity - newItem.quantity })] });
                      self.updateCart();
                    }
                  } else {
                    self.ecommerceDataLayer('remove_from_cart', { items: [item] });
                    self.updateCart();
                  }
                }
              });
            }
          }
          return response;
        }.bind(this));
      };

      // XHR override
      var origXMLHttpRequest = XMLHttpRequest;
      XMLHttpRequest = function () {
        var requestURL;
        var xhr = new origXMLHttpRequest();
        var origOpen = xhr.open;
        var origSend = xhr.send;

        xhr.open = function (method, url) {
          requestURL = url;
          return origOpen.apply(this, arguments);
        };

        xhr.send = function () {
          if (requestURL && (
            requestURL.includes('/cart/add') ||
            requestURL.includes('/cart/change') ||
            /.*\/search\/?.*\?.*q=.+/.test(requestURL)
          )) {
            xhr.addEventListener('load', function () {
              if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 400) {
                if (/.*\/search\/?.*\?.*q=.+/.test(requestURL) && !requestURL.includes('&requestFrom=uldt')) {
                  var queryString = requestURL.split('?')[1];
                  var urlParams = new URLSearchParams(queryString);
                  var search_term = urlParams.get('q');
                  debounce(function () {
                    fetch(self.storeURL + '/search/suggest.json?q=' + search_term + '&resources[type]=product&requestFrom=uldt')
                      .then(function (r) { return r.json(); })
                      .then(function (data) {
                        var products = data.resources.results.products;
                        if (products.length) {
                          var fetchRequests = products.map(function (product) {
                            return fetch(self.storeURL + '/' + product.url.split('?')[0] + '.js')
                              .then(function (r) { return r.json(); })
                              .catch(function (e) { console.error('Error fetching:', e); });
                          });
                          Promise.all(fetchRequests).then(function (products) {
                            var items = products.map(function (product) {
                              return {
                                product_id: product.id, product_title: product.title,
                                variant_id: product.variants[0].id, variant_title: product.variants[0].title,
                                vendor: product.vendor, total_discount: 0,
                                final_price: product.price_min, product_type: product.type, quantity: 1
                              };
                            });
                            self.ecommerceDataLayer('search', { search_term: search_term, items: items });
                          });
                        } else {
                          self.ecommerceDataLayer('search', { search_term: search_term, items: [] });
                        }
                      });
                  });
                } else if (requestURL.includes('/cart/add')) {
                  var data = JSON.parse(xhr.responseText);
                  if (data.items && Array.isArray(data.items)) {
                    data.items.forEach(function (item) { self.ecommerceDataLayer('add_to_cart', { items: [item] }); });
                  } else {
                    self.ecommerceDataLayer('add_to_cart', { items: [data] });
                  }
                  self.updateCart();
                } else if (requestURL.includes('/cart/change')) {
                  var newCart = JSON.parse(xhr.responseText);
                  var oldCartItems = self.cart.items;
                  for (var i = 0; i < oldCartItems.length; i++) {
                    var item = oldCartItems[i];
                    var newItem = newCart.items.find(function (n) { return n.id === item.id; });
                    if (newItem) {
                      if (newItem.quantity > item.quantity) {
                        self.ecommerceDataLayer('add_to_cart', { items: [Object.assign({}, item, { quantity: newItem.quantity - item.quantity })] });
                        self.updateCart();
                      } else if (newItem.quantity < item.quantity) {
                        self.ecommerceDataLayer('remove_from_cart', { items: [Object.assign({}, item, { quantity: item.quantity - newItem.quantity })] });
                        self.updateCart();
                      }
                    } else {
                      self.ecommerceDataLayer('remove_from_cart', { items: [item] });
                      self.updateCart();
                    }
                  }
                }
              }
            });
          }
          return origSend.apply(this, arguments);
        };

        return xhr;
      };
    }

    searchPageData() {
      var self = this;
      var pageUrl = window.location.href;
      if (/.+\/search\?.*&?q=.+/.test(pageUrl)) {
        var queryString = pageUrl.split('?')[1];
        var urlParams = new URLSearchParams(queryString);
        var search_term = urlParams.get('q');
        fetch(self.storeURL + '/search/suggest.json?q=' + search_term + '&resources[type]=product&requestFrom=uldt')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.resources.results.products;
            if (products.length) {
              var fetchRequests = products.map(function (product) {
                return fetch(self.storeURL + '/' + product.url.split('?')[0] + '.js')
                  .then(function (r) { return r.json(); })
                  .catch(function (e) { console.error('Error fetching:', e); });
              });
              Promise.all(fetchRequests).then(function (products) {
                var items = products.map(function (product) {
                  return {
                    product_id: product.id, product_title: product.title,
                    variant_id: product.variants[0].id, variant_title: product.variants[0].title,
                    vendor: product.vendor, total_discount: 0,
                    final_price: product.price_min, product_type: product.type, quantity: 1
                  };
                });
                self.ecommerceDataLayer('search', { search_term: search_term, items: items });
              });
            } else {
              self.ecommerceDataLayer('search', { search_term: search_term, items: [] });
            }
          });
      }
    }

    miniCartData() {
      if (this.miniCartButton.length) {
        var self = this;
        if (this.miniCartAppersOn === 'hover') this.miniCartAppersOn = 'mouseenter';
        this.miniCartButton.forEach(function (selector) {
          document.querySelectorAll(selector).forEach(function (btn) {
            btn.addEventListener(self.miniCartAppersOn, function () {
              self.ecommerceDataLayer('view_cart', self.cart);
            });
          });
        });
      }
    }

    beginCheckoutData() {
      var self = this;
      document.addEventListener('pointerdown', function (event) {
        var targetElement = event.target.closest(self.beginCheckoutButtons.join(', '));
        if (targetElement) self.ecommerceDataLayer('begin_checkout', self.cart);
      });
    }

    viewCartPageData() {
      this.ecommerceDataLayer('view_cart', this.cart);
      if (!this.isAjaxCartIncrementDecrement) {
        var self = this;
        document.addEventListener('pointerdown', function (event) {
          var target = event.target.closest('a[href*="/cart/change?"]');
          if (target) {
            var linkUrl = target.getAttribute('href');
            var urlParams = new URLSearchParams(linkUrl.split('?')[1]);
            var newQuantity = urlParams.get('quantity');
            var line = urlParams.get('line');
            var cart_id = urlParams.get('id');
            if (newQuantity && (line || cart_id)) {
              var item = line ? Object.assign({}, self.cart.items[line - 1]) : self.cart.items.find(function (i) { return i.key === cart_id; });
              var evtName = newQuantity < item.quantity ? 'remove_from_cart' : 'add_to_cart';
              item.quantity = Math.abs(newQuantity - item.quantity);
              self.ecommerceDataLayer(evtName, { items: [item] });
            }
          }
        });
      }
    }

    productSinglePage() {
      var cfg = window.LucrativeConfig || {};
      var p = cfg.product;
      if (!p) return;

      var item = {
        product_id: p.id,
        variant_id: p.variant_id,
        product_title: p.title,
        line_level_total_discount: 0,
        vendor: p.vendor,
        sku: p.sku,
        product_type: p.type,
        item_list_id: p.collection_id,
        item_list_name: p.collection_title,
        final_price: p.price,
        quantity: 1
      };
      if (p.variant_title && p.variant_title !== 'Default Title') {
        item.variant_title = p.variant_title;
      }

      var variants = p.variants || [];
      this.ecommerceDataLayer('view_item', { items: [item] });

      if (this.shopifyDirectCheckoutButton.length) {
        var self = this;
        document.addEventListener('pointerdown', function (event) {
          var checkoutButton = event.target.closest(self.shopifyDirectCheckoutButton.join(', '));
          if (checkoutButton && (variants || self.quickViewVariants)) {
            var checkoutForm = checkoutButton.closest('form[action*="/cart/add"]');
            if (checkoutForm) {
              var variant_id = null;
              var varientInput = checkoutForm.querySelector('input[name="id"]');
              var varientIdFromURL = new URLSearchParams(window.location.search).get('variant');
              if (varientInput) {
                variant_id = parseInt(varientInput.value);
              } else if (varientIdFromURL) {
                variant_id = varientIdFromURL;
              } else if (item.variant_id) {
                variant_id = item.variant_id;
              }
              if (variant_id) {
                variant_id = parseInt(variant_id);
                var quantity = 1;
                var qSelector = checkoutForm.getAttribute('id');
                if (qSelector) {
                  var qInput = document.querySelector('input[name="quantity"][form="' + qSelector + '"]');
                  if (qInput) quantity = +qInput.value;
                }
                var variant = variants.find(function (v) { return v.id === variant_id; });
                if (variant && item) {
                  item.variant_id = variant_id;
                  item.variant_title = variant.title;
                  item.final_price = variant.price;
                  item.quantity = quantity;
                  self.ecommerceDataLayer('add_to_cart', { items: [item] });
                  self.ecommerceDataLayer('begin_checkout', { items: [item] });
                } else if (self.quickViewedItem) {
                  var qVariant = self.quickViewVariants.find(function (v) { return v.id === variant_id; });
                  if (qVariant) {
                    self.quickViewedItem.variant_id = variant_id;
                    self.quickViewedItem.variant_title = qVariant.title;
                    self.quickViewedItem.final_price = parseFloat(qVariant.price) * 100;
                    self.quickViewedItem.quantity = quantity;
                    self.ecommerceDataLayer('add_to_cart', { items: [self.quickViewedItem] });
                    self.ecommerceDataLayer('begin_checkout', { items: [self.quickViewedItem] });
                  }
                }
              }
            }
          }
        });
      }
    }

    collectionsPageData() {
      var cfg = window.LucrativeConfig || {};
      var col = cfg.collection;
      if (!col) return;

      var ecommerce = {
        items: col.products || [],
        item_list_id: col.id,
        item_list_name: col.title
      };
      this.ecommerceDataLayer('view_item_list', ecommerce);
    }

    addToWishListData() {
      if (!this.addToWishListSelectors || !this.addToWishListSelectors.addWishListIcon) return;
      var self = this;
      document.addEventListener('pointerdown', function (event) {
        var target = event.target;
        if (target.closest(self.addToWishListSelectors.addWishListIcon)) {
          var pageURL = window.location.href.replace(/\?.+/, '');
          var requestURL;
          if (/\/products\/[^/]+$/.test(pageURL)) {
            requestURL = pageURL;
          } else if (self.addToWishListSelectors.gridItemSelector && self.addToWishListSelectors.productLinkSelector) {
            var itemEl = target.closest(self.addToWishListSelectors.gridItemSelector);
            if (itemEl) {
              var linkEl = itemEl.querySelector(self.addToWishListSelectors.productLinkSelector);
              if (linkEl) {
                var link = linkEl.getAttribute('href').replace(/\?.+/g, '');
                if (link && /\/products\/[^/]+$/.test(link)) requestURL = link;
              }
            }
          }
          if (requestURL) {
            fetch(requestURL + '.json')
              .then(function (r) { return r.json(); })
              .then(function (result) {
                var data = result.product;
                if (data) {
                  self.ecommerceDataLayer('add_to_wishlist', { items: [{
                    product_id: data.id, variant_id: data.variants[0].id,
                    product_title: data.title, quantity: 1,
                    final_price: parseFloat(data.variants[0].price) * 100,
                    total_discount: 0, product_type: data.product_type,
                    vendor: data.vendor,
                    variant_title: data.variants[0].title !== 'Default Title' ? data.variants[0].title : undefined,
                    sku: data.variants[0].sku
                  }]});
                }
              });
          }
        }
      });
    }

    quickViewData() {
      if (!this.quickViewSelector.quickViewElement || !this.quickViewSelector.gridItemSelector || !this.quickViewSelector.productLinkSelector) return;
      var self = this;
      document.addEventListener('pointerdown', function (event) {
        var target = event.target;
        if (target.closest(self.quickViewSelector.quickViewElement)) {
          var itemEl = target.closest(self.quickViewSelector.gridItemSelector);
          if (itemEl) {
            var linkEl = itemEl.querySelector(self.quickViewSelector.productLinkSelector);
            if (linkEl) {
              var link = linkEl.getAttribute('href').replace(/\?.+/g, '');
              if (link && /\/products\/[^/]+$/.test(link)) {
                fetch(link + '.json')
                  .then(function (r) { return r.json(); })
                  .then(function (result) {
                    var data = result.product;
                    if (data) {
                      var dataLayerData = {
                        product_id: data.id, variant_id: data.variants[0].id,
                        product_title: data.title, quantity: 1,
                        final_price: parseFloat(data.variants[0].price) * 100,
                        total_discount: 0, product_type: data.product_type, vendor: data.vendor,
                        variant_title: data.variants[0].title !== 'Default Title' ? data.variants[0].title : undefined,
                        sku: data.variants[0].sku
                      };
                      self.ecommerceDataLayer('view_item', { items: [dataLayerData] });
                      self.quickViewVariants = data.variants;
                      self.quickViewedItem = dataLayerData;
                    }
                  });
              }
            }
          }
        }
      });

      if (this.shopifyDirectCheckoutButton.length) {
        document.addEventListener('pointerdown', function (event) {
          var checkoutButton = event.target.closest(self.shopifyDirectCheckoutButton.join(', '));
          if (self.quickViewVariants && self.quickViewedItem && self.quickViewVariants.length && checkoutButton) {
            var checkoutForm = checkoutButton.closest('form[action*="/cart/add"]');
            if (checkoutForm) {
              var quantity = 1;
              var varientInput = checkoutForm.querySelector('input[name="id"]');
              var qSelector = checkoutForm.getAttribute('id');
              if (qSelector) {
                var qInput = document.querySelector('input[name="quantity"][form="' + qSelector + '"]');
                if (qInput) quantity = +qInput.value;
              }
              if (varientInput) {
                var variant_id = parseInt(varientInput.value);
                if (variant_id) {
                  var variant = self.quickViewVariants.find(function (v) { return v.id === variant_id; });
                  if (variant && self.quickViewedItem) {
                    self.quickViewedItem.variant_id = variant_id;
                    self.quickViewedItem.variant_title = variant.title;
                    self.quickViewedItem.final_price = parseFloat(variant.price) * 100;
                    self.quickViewedItem.quantity = quantity;
                    self.ecommerceDataLayer('add_to_cart', { items: [self.quickViewedItem] });
                    self.ecommerceDataLayer('begin_checkout', { items: [self.quickViewedItem] });
                  }
                }
              }
            }
          }
        });
      }
    }

    ecommerceDataLayer(event, data) {
      var self = this;
      dataLayer.push({ ecommerce: null });
      var dataLayerData = {
        event: this.eventPrefix + event,
        ecommerce: {
          currency: this.cart.currency,
          items: data.items.map(function (item, index) {
            var di = {
              index: index,
              item_id: self.formattedItemId
                ? 'shopify_' + self.countryCode + '_' + item.product_id + '_' + item.variant_id
                : item.product_id.toString(),
              product_id: item.product_id.toString(),
              variant_id: item.variant_id.toString(),
              item_name: item.product_title,
              quantity: item.quantity,
              price: +((item.final_price / 100).toFixed(2)),
              discount: item.total_discount ? +((item.total_discount / 100).toFixed(2)) : 0
            };
            if (item.product_type)  di.item_category = item.product_type;
            if (item.vendor)        di.item_brand = item.vendor;
            if (item.variant_title && item.variant_title !== 'Default Title') di.item_variant = item.variant_title;
            if (item.sku)           di.sku = item.sku;
            if (item.item_list_name) di.item_list_name = item.item_list_name;
            if (item.item_list_id)  di.item_list_id = item.item_list_id.toString();
            // Attribuzione cross-sell: la line-item property _cross_sell (settata dal
            // quick-add sui bottoni con data-list-name) diventa item_list_name su GA4.
            if (!di.item_list_name && item.properties && item.properties._cross_sell) {
              di.item_list_name = item.properties._cross_sell;
            }
            return di;
          })
        }
      };

      if (data.total_price !== undefined) {
        dataLayerData.ecommerce.value = +((data.total_price / 100).toFixed(2));
      } else {
        dataLayerData.ecommerce.value = +(dataLayerData.ecommerce.items.reduce(function (t, i) { return t + i.price * i.quantity; }, 0)).toFixed(2);
      }
      if (data.item_list_id)   dataLayerData.ecommerce.item_list_id = data.item_list_id;
      if (data.item_list_name) dataLayerData.ecommerce.item_list_name = data.item_list_name;
      if (data.search_term)    dataLayerData.search_term = data.search_term;

      if (self.dataSchema.dynamicRemarketing && self.dataSchema.dynamicRemarketing.show) {
        dataLayer.push({ dynamicRemarketing: null });
        dataLayerData.dynamicRemarketing = {
          value: dataLayerData.ecommerce.value,
          items: dataLayerData.ecommerce.items.map(function (i) {
            return { id: i.item_id, google_business_vertical: self.dataSchema.dynamicRemarketing.business_vertical };
          })
        };
      }

      if (!self.dataSchema.ecommerce || !self.dataSchema.ecommerce.show) {
        delete dataLayerData.ecommerce;
      }

      dataLayer.push(dataLayerData);
    }

    formData() {
      var self = this;
      document.addEventListener('submit', function (event) {
        var targetForm = event.target.closest('form[action^="/contact"]');
        if (targetForm) {
          var formData = {
            form_location: window.location.href,
            form_id: targetForm.getAttribute('id'),
            form_classes: targetForm.getAttribute('class')
          };
          var formType = targetForm.querySelector('input[name="form_type"]');
          var inputs = targetForm.querySelectorAll('input:not([type=hidden]):not([type=submit]), textarea, select');
          inputs.forEach(function (input) {
            if (input.name && input.value) {
              var matches = input.name.match(/\[(.*?)\]/);
              if (matches && matches.length > 1) formData[matches[1]] = input.value;
            }
          });
          if (formType && formType.value === 'customer') {
            dataLayer.push({ event: self.eventPrefix + 'newsletter_signup', ...formData });
          } else if (formType && formType.value === 'contact') {
            dataLayer.push({ event: self.eventPrefix + 'contact_form_submit', ...formData });
          }
        }
      });
    }

    phoneClickData() {
      var self = this;
      document.addEventListener('click', function (event) {
        var target = event.target.closest('a[href^="tel:"]');
        if (target) {
          dataLayer.push({
            event: self.eventPrefix + 'phone_number_click',
            page_location: window.location.href,
            link_classes: target.getAttribute('class'),
            link_id: target.getAttribute('id'),
            phone_number: target.getAttribute('href').replace('tel:', '')
          });
        }
      });
    }

    emailClickData() {
      var self = this;
      document.addEventListener('click', function (event) {
        var target = event.target.closest('a[href^="mailto:"]');
        if (target) {
          dataLayer.push({
            event: self.eventPrefix + 'email_click',
            page_location: window.location.href,
            link_classes: target.getAttribute('class'),
            link_id: target.getAttribute('id'),
            email_address: target.getAttribute('href').replace('mailto:', '')
          });
        }
      });
    }
  }
  // end Lucrative_DataLayer

  document.addEventListener('DOMContentLoaded', function () {
    try {
      new Lucrative_DataLayer();
    } catch (error) {
      console.log(error);
    }
  });
})();
